/* eslint-disable import/prefer-default-export */
export const emailCompositionSteps = [
  {
    title: 'Introduction',
    description:
      'This is the place to warmly greet your client, referring to a past interaction. If the client does not know you, introduce yourself using your value proposition.',
    id: 'introduction',
  },
  {
    title: 'Offer',
    description:
      'Think: What is the client interested in? Here is where you let them know about current offers, new products, and/or send a Look.',
    withSkipButton: true,
    id: 'offer',
  },
  {
    title: 'Why',
    description:
      'Use what you know about this client to explain why the product, Look, and/or promotion is relevant and exciting.',
    id: 'why',
  },
  {
    title: 'Next Steps',
    description:
      'This is a good place to ask a question and gather feedback. You can also invite them for a virtual or in-store appointment.',
    id: 'nextSteps',
  },
];
